
import React from 'react';

 
const MapButton = (props) => {
    const handleRouteClick = (e) => {
        e.stopPropagation();
        props.context.componentParent.formHandler(props.data);
    };

    return (
        <div className="map-icon-component">
			{/*<button onClick={handleClick} className="custom-btn label label-success" title="View Timeline"><i className="icofont icofont-tree-alt"></i> Timeline </button>
            &nbsp;| &nbsp;
            */}
            <button onClick={handleRouteClick} className="custom-btn label label-success" title="View Route"><i className="icofont icofont-map-pins f25"></i> </button>
       
        </div>
    );
};

export default MapButton;
